import React from "react";
import {cn} from "../utils";

const NotificationIcon = (
    {
        className,
        color
    }: {
        className?: string,
        color?: string
    } & React.SVGProps<SVGSVGElement>) => (
    <svg fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        className={cn(className)}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill={color || "currentColor"} clipRule="evenodd" fillRule="evenodd">
            <path
                d="m11.4428 2.25h1.0572c.4142 0 .75.33579.75.75s-.3358.75-.75.75h-1c-2.26037 0-3.8802.00159-5.1121.16722-1.21033.16272-1.93328.47131-2.46633 1.00435-.53304.53305-.84163 1.256-1.00435 2.46632-.16563 1.2319-.16722 2.85171-.16722 5.11211s.00159 3.8802.16722 5.1121c.16272 1.2103.47131 1.9333 1.00435 2.4663.53305.5331 1.256.8417 2.46633 1.0044 1.2319.1656 2.85173.1672 5.1121.1672 2.2604 0 3.8802-.0016 5.1121-.1672 1.2103-.1627 1.9333-.4713 2.4663-1.0044.5331-.533.8417-1.256 1.0044-2.4663.1656-1.2319.1672-2.8517.1672-5.1121v-1c0-.4142.3358-.75.75-.75s.75.3358.75.75v1.0572c0 2.1907 0 3.9114-.1806 5.2548-.1851 1.3766-.5721 2.4689-1.4303 3.3271s-1.9505 1.2452-3.3271 1.4303c-1.3434.1806-3.0641.1806-5.2548.1806h-.1144c-2.19068 0-3.91136 0-5.25478-.1806-1.37665-.1851-2.46891-.5721-3.32711-1.4303s-1.24523-1.9505-1.43032-3.3271c-.18061-1.3434-.1806-3.0641-.18059-5.2548v-.1144c-.00001-2.1907-.00002-3.91136.18059-5.25478.18509-1.37665.57212-2.46891 1.43032-3.32711s1.95046-1.24523 3.32711-1.43032c1.34342-.18061 3.0641-.1806 5.25478-.18059z" />
            <path
                d="m18.5 2.75c-1.5188 0-2.75 1.23122-2.75 2.75s1.2312 2.75 2.75 2.75 2.75-1.23122 2.75-2.75-1.2312-2.75-2.75-2.75zm-4.25 2.75c0-2.34721 1.9028-4.25 4.25-4.25s4.25 1.90279 4.25 4.25-1.9028 4.25-4.25 4.25-4.25-1.90279-4.25-4.25z" />
            <path
                d="m6.25 11c0-.4142.33579-.75.75-.75h4c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-4c-.41421 0-.75-.3358-.75-.75z" />
            <path
                d="m6.25 16c0-.4142.33579-.75.75-.75h8c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-8c-.41421 0-.75-.3358-.75-.75z" />
        </g>
    </svg>
);

export {NotificationIcon};
